import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
  class: "channels-page"
};
const _hoisted_2 = {
  key: 1,
  class: "row channel-list"
};
const _hoisted_3 = {
  class: "channel-card"
};
const _hoisted_4 = {
  class: "card-thumb"
};
const _hoisted_5 = {
  key: 0,
  class: "live-badge"
};
const _hoisted_6 = {
  class: "video-count-badge"
};
const _hoisted_7 = {
  class: "card-body"
};
const _hoisted_8 = {
  class: "card-title"
};
const _hoisted_9 = {
  class: "card-meta"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_b_col = _resolveComponent("b-col");
  const _component_b_row = _resolveComponent("b-row");
  const _component_b_img = _resolveComponent("b-img");
  const _component_router_link = _resolveComponent("router-link");
  const _directive_b_tooltip = _resolveDirective("b-tooltip");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [$data.loading ? (_openBlock(), _createBlock(_component_b_row, {
    key: 0,
    class: "mb-4"
  }, {
    default: _withCtx(() => [_createVNode(_component_b_col, {
      cols: "12",
      class: "text-center"
    }, {
      default: _withCtx(() => [_createVNode(_component_b_spinner), _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)), _cache[1] || (_cache[1] = _createTextVNode(" Loading Videos", -1)), _cache[2] || (_cache[2] = _createElementVNode("br", null, null, -1)), _cache[3] || (_cache[3] = _createElementVNode("br", null, null, -1))], undefined, true),
      _: 1
    })], undefined, true),
    _: 1
  })) : _createCommentVNode("", true), !$data.loading ? (_openBlock(), _createElementBlock("div", _hoisted_2, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.channels, c => {
    return _openBlock(), _createElementBlock("div", {
      key: c.id,
      class: "col-12 col-sm-6 col-md-4 col-lg-3 mb-4 channel-item"
    }, [_withDirectives((_openBlock(), _createBlock(_component_router_link, {
      to: '/video/channel/' + c.id,
      class: "channel-card-link",
      title: c.description || c.name
    }, {
      default: _withCtx(() => [_createElementVNode("article", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_b_img, {
        src: $options.getChannelImage(c),
        alt: c.name,
        fluid: "",
        class: "card-thumb-img"
      }, null, 8, ["src", "alt"]), $options.isLiveChannel(c) ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[4] || (_cache[4] = [_createElementVNode("span", {
        class: "live-dot"
      }, null, -1), _createTextVNode(" LIVE ", -1)]))])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_6, _toDisplayString($options.getVideoCount(c)) + " " + _toDisplayString($options.getVideoCount(c) === 1 ? 'video' : 'videos'), 1)]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, _toDisplayString(c.name), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("span", null, _toDisplayString($options.getVideoCount(c)) + " On-Demand", 1)])])])], undefined, true),
      _: 2
    }, 1032, ["to", "title"])), [[_directive_b_tooltip, void 0, void 0, {
      hover: true
    }]])]);
  }), 128))])) : _createCommentVNode("", true)]);
}